import { useTranslation } from 'react-i18next';

export default function SearchGuide() {
  const { t } = useTranslation();
  const ops = t('searchPage.operators.items', { returnObjects: true }) as { k: string; v: string; ex?: string }[];
  const tips = t('searchPage.tips', { returnObjects: true }) as string[];
  const example = t('searchPage.example', { returnObjects: true }) as { label: string; query: string; note?: string };
  const savedSteps = t('searchPage.saved.steps', { returnObjects: true }) as string[];

  return (
    <div className="surface-body">
      <h1>{t('searchPage.title')}</h1>

      <div className="note" role="note" aria-live="polite">
        <h2>{t('searchPage.introTitle')}</h2>
        <p style={{ margin: 0 }}>{t('searchPage.introBody')}</p>
      </div>

      <section style={{ marginTop: 10 }}>
        <h2>{t('searchPage.operators.title')}</h2>
        <ul style={{ marginTop: 6, paddingLeft: '1.2rem' }}>
          {ops.map((o, i) => (
            <li key={i} style={{ margin: '6px 0' }}>
              <code>{o.k}</code> - {o.v} {o.ex ? <em>({o.ex})</em> : null}
            </li>
          ))}
        </ul>
      </section>

      <section style={{ marginTop: 10 }}>
        <h2>{t('searchPage.common.title')}</h2>
        <ul style={{ marginTop: 6, paddingLeft: '1.2rem' }}>
          <li><code>@move</code> - {t('searchPage.common.move')}</li>
          <li><code>@type</code> - {t('searchPage.common.moveType')}</li>
          <li><code>@special</code> - {t('searchPage.common.special')}</li>
          <li><code>0–4*</code> - {t('searchPage.common.appraisal')}</li>
          <li><code>1Attack / 2Defense / 3HP</code> - {t('searchPage.common.ivbands')}</li>
          <li><code>cp / hp / distance / age / year</code> - {t('searchPage.common.numeric')}</li>
          <li><code>legendary / mythical / ultrabeasts</code> - {t('searchPage.common.tiers')}</li>
          <li><code>shadow / purified / shiny / lucky</code> - {t('searchPage.common.flags1')}</li>
          <li><code>costume / favorite / defender / traded</code> - {t('searchPage.common.flags2')}</li>
          <li><code>evolve / evolvenew / item / tradeevolve / @weather</code> - {t('searchPage.common.evolveWeather')}</li>
          <li><code>+name</code> - {t('searchPage.common.family')}</li>
          <li><code>#tag</code> - {t('searchPage.common.tags')}</li>
        </ul>
      </section>

      <section style={{ marginTop: 10 }}>
        <h2>{t('searchPage.examplesTitle')}</h2>
        <div className="example" style={{ margin: '10px 0', padding: 8, border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10 }}>
          <div style={{ fontWeight: 600 }}>{example.label}</div>
          <code style={{ display: 'block', marginTop: 4, userSelect: 'all' }}>{example.query}</code>
          {example.note ? <div style={{ marginTop: 4, fontSize: 12, opacity: 0.8 }}>{example.note}</div> : null}
          <button
            className="btn"
            onClick={() => navigator.clipboard.writeText(example.query)}
            style={{ marginTop: 6 }}
            aria-label={t('common.copy') as string}
            title={t('common.copy') as string}
          >
            {t('common.copy')}
          </button>
        </div>
      </section>

      <section style={{ marginTop: 10 }}>
        <h2>{t('searchPage.saved.title')}</h2>
        <ol style={{ marginTop: 6, paddingLeft: '1.2rem' }}>
          {savedSteps.map((s, i) => <li key={i} style={{ margin: '6px 0' }}>{s}</li>)}
        </ol>
      </section>

      <section style={{ marginTop: 10 }}>
        <h2>{t('searchPage.notesTitle')}</h2>
        <ul style={{ marginTop: 6, paddingLeft: '1.2rem' }}>
          {tips.map((s, i) => <li key={i} style={{ margin: '6px 0' }}>{s}</li>)}
        </ul>
      </section>
    </div>
  );
}
